import React, { useContext, useEffect, useRef, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import styled from "styled-components";
import { ethers } from "ethers";
import DownArrow from "../../Images/downarrow.png"
import walleticon from "../../Images/Icons/walleticon.png"
import { useNavigate } from "react-router-dom";
import { userBalanceContext } from "../../context/userBalanceContext";
import {
  init,
  balanceOf,
  getBalance,
} from "../../config/provider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
// import { Manager } from "socket.io-client";
import environmentVariables from "../../config/environmentVariables";
import { userInfoContext } from "../../context/userInfoContext";
import { truncateNumberBalance } from "../../config/common";
import { useSocket } from "../../context/socketContext";
const BellIcon = `${environmentVariables?.cdnUrl}bell.png`
const BlueArrow = `${environmentVariables?.cdnUrl}blue_arrow.png`
const MldTokenIcon   = `${environmentVariables?.cdnUrl}mldtokenicon.png`
const LordTokenIcon  = `${environmentVariables?.cdnUrl}lordtokenicon.png`
const MaticTokenIcon = `${environmentVariables?.cdnUrl}matictokenicon.png`
const ustdTokenIcon  = `${environmentVariables?.cdnUrl}usdticonupdated.png`

// const manager = new Manager(`${environmentVariables?.apiUrl}`);
// const socket = manager.socket("/");
const TokenContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Root = styled.div`
  margin: 20px 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
`;

const CrossIcon = styled.img`
    position: absolute;
    top: 15px;
    right: 20px;
    width: 28px;
    height: 28px;
    display: none;
    @media (max-width: 768px) {
      display: block;
  }
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 90%;
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  z-index: 1;
  display: flex;
  gap: 10px;
  justify-content: end;
  align-items: center;
  text-align: center;

  @media (max-width: 425px) {
    right: 5%;
    /* flex-direction: column; */
    align-items: center;
    text-align: center;
    top: 0;
    gap: 5px;
  }
`;

const Button = styled.button`
  background: #172930;
  border-radius: 50px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #153339;
  padding: 12px 30px;
  color: #267383;
  @media (max-width: 425px) {
    font-size: 14px;
    padding: 14px 30px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  text-align: center;
`;

const AddressWrapper = styled.div``;

const AddressText = styled.text`
  font-size: 20px;
  font-weight: 800;
  text-align: left;
  color: #fff;
  line-height: 50px;
  padding: 0 10px;
  display: flex;
  @media (max-width: 768px) {
    /* display: none; */
  }
  @media (max-width: 500px) {
    font-size: 16px;
    font-weight: 800;
    text-align: left;
    padding: 0 5px;
  }
`;
const CopyIcon = styled.div`
  color: white;
  cursor: pointer;
  padding: 0 10px 0 0;
  @media (max-width: 425px) {
    padding: 0 5px 0 5px;
  }
`;
const BellMain = styled.div`
  position: relative;
`;
const WalletBalanceContainer = styled.div`
  display:flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 0px 10px;
  border-radius: 4px;
  cursor: pointer;
  @media (max-width:500px){
    background: none;
    padding: 0;
  }
`
const WalletBalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width:500px){
    display: none;
  }
`
const WalletBalanceText = styled.div`
font-size: 20px;
color: #fff;
font-weight: 800;
margin-right: 3px;
`
const WalletBalanceCurrency = styled.div`
font-size: 12px;
font-weight: 400;
color: #fff;
`
const WalletBalanceDropDown =  styled.div``
const WalletBalanceDropDownIcon = styled.img`
  color: #fff;
  padding:8px;
  width: 40px;
  @media (max-width:500px){
    display: none;
  }
`
const WalletBalanceIcon = styled.div`
  padding: 8px;
  @media (max-width:500px){
    padding: 0;
  }
`
const WalletBalanceIconImg = styled.img`
@media (max-width:500px){
  margin-left: 6px;
  width: 20px;
}
`
const Bell = styled.img`
  width: 25px;
  cursor: pointer;
  @media (max-width: 425px) {
    width: 20px;
  }
`;
const BellDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50px;
  background-color: #f71212;
  position: absolute;
  top: 0;
  right: 0;
`;
const NotificationPopMain = styled.div`
  background-color: #172930;
  border-radius: 10px 0 10px 10px;
  padding: 20px;
  color: #d1d1d1;
  font-size: 18px;
  /* box-shadow: 0px 0px 5px 5px #000; */
  position: absolute;
  z-index: 2;
  top: 60px;
  right: 240px;
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 500px;
  overflow-y: scroll;
  z-index: 999999;
  box-shadow: 0px 0px 11px 8px #242424a6;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #1e333b;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #1e889e;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  @media (max-width: 768px) {
    top: 0;
    left: 0;
    border-radius: 10px;
    right: 0;
    position: fixed;
    width: 100%;
    height: 100vh;
  }
  /* @media (max-width: 425px) {
    top: 50px;
    left: -49px;
    border-radius: 10px;
    right: 0;
  }
  @media (max-width: 375px) {
    left: -42px;
  } */
`;
const NotifivationsHead = styled.div`
  border-bottom: 1px solid #2b434d;
  padding-bottom: 15px;
  font-weight: 600;
  font-size: 18px;
  color: #fff;
`;
const Notifivations = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #2b434d;
`;
const NotifivationsLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
const LeftFrom = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1e889e;
`;
const LeftTime = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #526366;
  padding-top: 5px;
`;
const NotifivationsRight = styled.div``;

const UserProfile = styled.div`
  /* border-left: 1px solid #2aabcd1a; */
  /* padding-left: 20px; */
  display: flex;
  align-items: center;
`;

const Avatar = styled.img`
  /* width: 45px;
  height: 45px;
  border-radius: 50%;*/
  cursor: pointer;
  width: 45px;
  height: 45px;
  border: 1px solid blue;
  border-radius: 50%;
`;

const FirstLetterName = styled.div`
  color: white;
  background-color: #205562;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;
const NameCo = styled.div`
  color: #fff;
  text-transform: capitalize;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  padding-left: 10px;
  line-height: normal;
  text-transform: capitalize;
  @media (max-width:500px){
    display: none;
  }
`;
const Drop = styled.img`
  border-radius: 4px;
  /* background: #ffffff1c; */
  color: #fff;
  padding: 8px;
  width: 40px;
  cursor: pointer;
  @media (max-width:500px){
    display: none;
  }
  /* margin-left: 20px; */
`;


const DropdownContent = styled.div`
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  border-radius: 4px;
  right: 0px;
  top: 75%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  display: ${(props) => (props.isOpen ? "block" : "none")};
`;

const DropdownItem = styled.div`
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: open-sans, sans-serif;

  &:hover {
    background-color: #f1f1f1;
  }
`;



const ImageTextWrapper = styled.div`
  display: flex;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 30px;
  height: 30px;
  background-color: none;
  border-radius: 25px;
  padding-left: 5px;
`;

const Image = styled.img`
  width: 25px;
`;

const TokenTextWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0 8px;
  position: relative;
`;

const Tokenpricewrapper = styled.div`
  font-size: 18px;
  font-weight: 400;
  font-family: "SweraDemo";
  display: flex;
  flex-direction: column;
`;

const Tokenprice = styled.div`
  font-family: "lato";
  /* text-align: left; */
  font-size: 16px;
  font-weight: 600;
  color: #25A8C5;
  font-family: 'Poppins', sans-serif;
  /* font-weight: 600; */
  line-height: 1;
`;
const TokenText = styled.text`
  font-family: "lato";
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 1;
`;
const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownContainerBalance = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownBox = styled.div`
  position: absolute;
  right: 60px;
  top: 22px;
  margin-top: 8px;
  width: 180px;
  background-color: #12171C;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  padding: 10px 0;
  font-family: 'Open Sans', sans-serif;
  z-index: 1000;
  @media (max-width:500px){
    right: -11px;
    width: 150px;
  }
`;

const DropdownBoxBalance = styled.div`
  position: absolute;
  right: 368px;
  top: 22px;
  margin-top: 8px;
  width: 250px;
  background-color: #0B1A24;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  padding: 10px 0;
  font-family: 'Open Sans', sans-serif;
  z-index: 1000;
  @media (max-width:500px){
    right: -26px;
    width: 98vw;
  }
`;



const DropdownItemNew = styled.button`
  width: 100%;
  padding: 10px 20px;
  background: none;
  border: none;
  color: white;
  text-align: left;
  cursor: pointer;
  font-size: 20px;
  font-family: 'Open Sans', sans-serif;
  &:hover {
    background-color: #1F2937;
  }
  @media (max-width:500px){
    font-size: 14px;
    padding: 5px 15px;
  }
`;

const DropdownItemBalance = styled.button`
  width: 100%;
  padding: 5px 20px;
  background: none;
  border: none;
  color: white;
  text-align: left;
  cursor: pointer;
  font-size: 20px;
  font-family: 'Open Sans', sans-serif;
  &:hover {
    background-color: #1F2937;
  }
  @media (max-width:500px){
    font-size: 14px;
    padding: 5px 15px;
  }
`;



const Divider = styled.hr`
  height: 1px;
  width: 90%;
  background-color: #153339;
  margin: 6px auto;
  border-radius: 1px;
  border: none;
`;

const DividerBalance = styled.hr`
  height: 1px;
  width: 90%;
  background-color: #153339;
  margin: 6px auto;
  border-radius: 1px;
  border: none;
`;

const Pointer = styled.div`
  position: absolute;
  top: -6px;
  right: 24px;
  width: 12px;
  height: 12px;
  background-color: #12171C;
  transform: rotate(45deg);
  z-index: -1;
`;
const PointerBalance = styled.div`
  position: absolute;
  top: -6px;
  right: 24px;
  width: 12px;
  height: 12px;
  background-color: #0B1A24;
  transform: rotate(45deg);
  z-index: -1;
  @media (max-width:500px){
    right: 210px;
  }
  @media (max-width:425px){
    right: 200px;
  }
`;

const LoginLogoutComponent = ({
  allContractDetails,
  setAllContractDetails,
  setIsNotificationOpen,
  isNotificationOpen,
  data,
  setWalletPopUpOpen,
  walletPopUpOpen,
  showDropdown,
  setShowDropDown,
  showBalancePopup,
  setShowBalancePopup,
}) => {
  const [address, setAddress] = useState("");
  const [imageError,setImageError] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [notificationData, setNotificationData] = useState(null);
  const [isNotification, setIsNotification] = useState(false);
  const {userAccInfo,setUserAccInfo}=useContext(userInfoContext);
  const navigate = useNavigate();  
  const socket = useSocket();
  const copyRef = useRef(null);
  const { userBalance, setUserBalance } = useContext(userBalanceContext);
  // const [userBalance, setUserBalance] = useState({
  //   MLDBalance: 0,
  //   LORDBalance: 0,
  //   MLD: 0,
  //   LORD: 0,
  //   MATICBalance: 0,
  //   MATIC: 0,
  // });

  const resetBalance = () => {
    setUserBalance({
      MLDBalance: 0,
      LORDBalance: 0,
      MLD: 0,
      LORD: 0,
      MATICBalance: 0,
      MATIC: 0,
    });
  };
  const getNotificationData = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getusertokentransferdata/${allContractDetails?.address}`,
        {headers:{
          authorization:`Bearer ${userAccInfo}`
        }}
      )
      .then((res) => {
        // console.log(res.data.data);
        setNotificationData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const CopyAddress = async () => {
    try {
      if (copyRef.current) {
        await navigator.clipboard.writeText(copyRef.current.value);
        toast.success("Copied !", {
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error("Error copying text:", error);
      toast.error("Copy failed");
    }
  };
  const getMonthName = (num) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sepr",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[num];
  };
  const getConvertedTime = (unixTimestamp) => {
    const date = new Date(unixTimestamp);

    // Get the various components of the date and time
    const year = date.getFullYear();
    const month = getMonthName(date.getMonth()); // Months are zero-indexed, so add 1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // You can format these components as needed, for example, in a user-friendly string
    const formattedDate = `${month} ${day}, ${hours}:${minutes}`;

    // console.log(formattedDate);
    return formattedDate;
  };
  const getUserBalance = (address) => {
    setUserBalance((prev) => ({ ...prev, loading: true }));
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserbalance/${address}`,
        {headers:{authorization:`Bearer ${userAccInfo}`}}
      )
      .then((res) => {
        // console.log(res.data.data);
        if (res?.data?.success == true) 
          setUserBalance({
            MLDBalance: res?.data?.data?.MLDBalance || 0,
            LORDBalance: res?.data?.data?.LORDBalance || 0,
            MATICBalance: res?.data?.data?.MATICBalance || 0,
            USDTBalance: res?.data?.data?.USDTBalance || 0,
            MLD: res?.data?.data?.MLDBalanceDec || 0,
            LORD: res?.data?.data?.LORD || 0,
            MATIC: res?.data?.data?.MATIC || 0,
            USDT: res?.data?.data?.USDT || 0,
            LORDUSD: res?.data?.data?.LORDUSD || 0,
            MATICUSD: res?.data?.data?.MATICUSD || 0,
            MLDUSD: res?.data?.data?.MLDUSD || 0,
            MLDBalanceDec: res?.data?.data?.MLDBalanceDec || 0,
            LORDBalance: res?.data?.data?.LORDBalance || 0,
            loading:false,
          });
        else
          setUserBalance({
            MLDBalance: 0,
            LORDBalance: 0,
            MATICBalance: 0,
            USDTBalance: 0,
            MLD: 0,
            LORD: 0,
            MATIC: 0,
            USDT: 0,
            LORDUSD: 0,
            MATICUSD: 0,
            MLDUSD: 0,
            MLDBalanceDec: 0,
            LORDBalance: 0,
            loading:false,
          });
      })
      .catch((err) => console.log(err));
  };

  const setUserToken=(res)=>{
    if(res?.idToken){
      let loginType='provider';
      if(res?.userInfo?.typeOfLogin){
        loginType='provider';
      }else{
        loginType='email'
      }
      let data={
        userName:res?.userInfo?.email||res?.userInfo?.name||res?.userInfo?.verifierId||'metamask',
        address:res?.address,
        loginType:loginType
      }
      let config={
        method:"post",
        url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/token`,
        headers:{
          authorization:`Bearer ${res?.idToken?.idToken}`
        },
      }
      axios.post(config.url, data, config)
      .then( respnse=>{
        // console.log(respnse,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;s')
        if(respnse?.data?.data){
          localStorage.setItem('userinfo',respnse?.data?.data);
          setUserAccInfo(respnse?.data?.data);          
        }
      }).catch(async err=>{
        console.log(err);
        // toast.error(err?.response?.data?.message||err?.message)
        localStorage.clear();
        await logoutWallet();
      })
    }else{
      // toast.error("id token is required")
    }

  }
  
  useEffect(()=>{
    if(allContractDetails?.address){
      socket.on("register",allContractDetails?.address.toLowerCase())
      socket.on("notifications",(data)=>{
          getUserBalance(allContractDetails?.address)
          getNotificationData();
          setIsNotification(true)
        })
      }
      return ()=>{
        socket.off("notifications")
      }
    },[socket,allContractDetails])

  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails?.address;
      setAddress(address);
      getNotificationData();
    } else {
      setAddress("");
    }
  }, [allContractDetails]);
  useEffect(() => {
    // console.log(".................", data)
    if (localStorage.getItem("Web3Auth-cachedAdapter")) {
      setIsLoading(true);
      init()
        .then(async (response) => {
          setAllContractDetails(response);
          setUserToken(response)
          setIsLoading(false);
          if (!response) {
            setIsLoading(response);
          }
        })
        .catch((err) => {
          console.log(err, "responseafterlogin");
          setIsLoading(false);
        });
    }
  }, []);

  const getNotificationComponents = () => {
    if (notificationData == null) {
      return (
        <NotificationPopMain>
          <div>
            <NotifivationsHead>Notifications</NotifivationsHead>
            <Notifivations>Loading...</Notifivations>
          </div>
        </NotificationPopMain>
      );
    } else if (notificationData.length == 0) {
      return (
        <NotificationPopMain>
          <div>
            <NotifivationsHead>Notifications</NotifivationsHead>
            <Notifivations>No Data to show</Notifivations>
          </div>
        </NotificationPopMain>
      );
    } else {
      <NotificationPopMain>
        <div>
          <NotifivationsHead>Notifications</NotifivationsHead>
          {notificationData.map((val) => (
            <Notifivations>
              <NotifivationsLeft>
                <LeftFrom>{`From ${val.from.slice(0, 6)}...${val.from.slice(
                  -6
                )}`}</LeftFrom>
                <LeftTime>Recieved on Oct 6, 16.30</LeftTime>
              </NotifivationsLeft>
              <NotifivationsRight>2.00 $MLD</NotifivationsRight>
            </Notifivations>
          ))}
        </div>
      </NotificationPopMain>;
    }
  };
  const connectWallet = async () => {
    setIsLoading(true);
    try {
      const data = await init();
      setIsLoading(false);
      // console.log(".................", data);
      setAllContractDetails(data);
      setUserToken(data)
      const address = data.address;
      
      // console.log(allContractDetails, "sr");
      const mldBal = await balanceOf(data?.mldTokenContract, address);
      const lordBal = await balanceOf(data?.lordTokenContract, address);
      const maticBal = await getBalance(data.provider, address);
      // await approve(data?.mldTokenContract, metaspaceNFTMarketplaceAddress);
      // await approve(data?.lordTokenContract, metaspaceNFTMarketplaceAddress);
      // await approve(data?.usdtTokenContract, metaspaceNFTMarketplaceAddress);
      // await approve(data?.mldTokenContract, metaspaceNFTMarketplaceAddress);
      // const ownership=await transferOwnership(data.metalordNFTManagerContract,'0x465d2634aC8DE6672A220F5034d8ad690b93cF72')
      // const owner=await data.metalordNFTManagerContract(address,'0x5bDb767f63376Dbc8B8AFA1E6d8b193fD7320721')
      // console.log('ownership', ownership)
      setUserBalance({
        MLDBalance: parseInt(mldBal),
        LORDBalance: parseInt(lordBal),
        MLD: ethers.formatEther(mldBal),
        LORD: ethers.formatEther(lordBal),
        MATICBalance: parseInt(maticBal),
        MATIC: ethers.formatEther(maticBal),
      });
      setIsLoading(false);
    } catch (error) {
      console.log("Error:", error);
    }

    setIsLoading(false);
  };

  const logoutWallet = async () => {
    setIsLoading(true);

    try {
      await allContractDetails?.logout();
      resetBalance();
      setAllContractDetails(null);
    } catch (error) {
      console.log("Error:", error);
    }
    setIsLoading(false);
  };

  return (
    <Root>
      <LoadingOverlay active={isLoading} spinner>
        <Container>
          {address!==null&&address!=""&&address!=undefined ? (
            <Wrapper>

{isNotificationOpen && (
                    <NotificationPopMain>
                      <div>
                        <NotifivationsHead>Notifications <CrossIcon src={BlueArrow} /></NotifivationsHead>
                        {notificationData &&
                          notificationData.map((val) => (
                            <Notifivations>
                              <NotifivationsLeft>
                                <LeftFrom>{`From ${val.from.slice(
                                  0,
                                  6
                                )}...${val.from.slice(-6)}`}</LeftFrom>
                                <LeftTime>{`Recieved on ${getConvertedTime(
                                  val?.time
                                )}`}</LeftTime>
                              </NotifivationsLeft>
                              <NotifivationsRight>{`${val?.amount} ${val?.currency=="MLD"||val?.currency=="Lord"?"$":""}${val?.currency}`}</NotifivationsRight>
                            </Notifivations>
                          ))}
                      </div>
                    </NotificationPopMain>
                  )}


              <ButtonWrapper>
                <BellMain>
                  <Bell
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsNotification(false);
                      setIsNotificationOpen(!isNotificationOpen);
                    }}
                    src={BellIcon}
                  />
                  {isNotification && <BellDot></BellDot>}

                  
                </BellMain>
                <WalletBalanceContainer onClick={(e)=>{e.stopPropagation();setShowBalancePopup(!showBalancePopup);setShowDropDown(false)}}>
                  <WalletBalanceIcon>
                    <WalletBalanceIconImg src={walleticon} />
                  </WalletBalanceIcon>
                  <WalletBalanceWrapper>
                    <WalletBalanceText>
                      {`${truncateNumberBalance(userBalance?.MLDBalanceDec,2)}`}
                    </WalletBalanceText>
                    <WalletBalanceCurrency>
                      $MLD
                    </WalletBalanceCurrency>
                    </WalletBalanceWrapper>
                    <WalletBalanceDropDown>
                      <WalletBalanceDropDownIcon src={DownArrow} />
                    </WalletBalanceDropDown>
                  
                </WalletBalanceContainer>
                <AddressWrapper>
                  <AddressText>
                    <CopyIcon onClick={CopyAddress}>
                      <i class="fa-solid fa-copy"></i>
                      <ToastContainer position="top-left" />
                    </CopyIcon>
                    {address.slice(0, 4)}...
                    {address.slice(address.length - 4, address.length)}
                    {/* {address} */}
                    <input
                      ref={copyRef}
                      type="text"
                      style={{ position: "absolute", left: "-9999px" }}
                      value={address}
                      readOnly
                    />
                  </AddressText>
                </AddressWrapper>
                
                {/* <Button onClick={logoutWallet} disabled={isLoading}>
                  Logout
                </Button> */}
                 <UserProfile>
                  {data?.profileImage && imageError==false ? (
                    <Avatar
                      onClick={(e)=>{e.stopPropagation();setShowDropDown(!showDropdown);setShowBalancePopup(false)}}
                      src={`${environmentVariables?.apiUrl}/${data?.profileImage}`}
                      onError={()=>setImageError(true)}
                    />
                  ) : (
                    <FirstLetterName onClick={(e)=>{e.stopPropagation();setShowDropDown(!showDropdown);setShowBalancePopup(false)}}>{data?.name.charAt(0).toUpperCase()}</FirstLetterName>
                  )}

                  <NameCo> {data?.name} </NameCo>
                  <Drop src={DownArrow} onClick={(e)=>{e.stopPropagation();setShowDropDown(!showDropdown);setShowBalancePopup(false)}} />
                  {/* <DropdownContent isOpen={showDropdown}>
                    <DropdownItem
                     
                    >  
                      Logout
                    </DropdownItem>
                  </DropdownContent> */}
                </UserProfile>
                {isLoading ? "Disconnecting..." : " "}
              </ButtonWrapper>
            </Wrapper>
          ) : (
            <ButtonWrapper>
              <Button onClick={connectWallet} disabled={isLoading}>
                Log In
              </Button>
              {isLoading ? "Connecting..." : " "}
            </ButtonWrapper>
          )}
        </Container>
      </LoadingOverlay>
      {showDropdown && <><DropdownContainer>
      <DropdownBox>
        <Pointer />
        <DropdownItemNew onClick={()=>navigate("/profile")}>Profile</DropdownItemNew>
        <Divider />
        <DropdownItemNew onClick={logoutWallet}>Logout</DropdownItemNew>
      </DropdownBox>
    </DropdownContainer></>}
    {
      showBalancePopup && <>
      <DropdownContainerBalance>
      <DropdownBoxBalance>
        <PointerBalance />
        <DropdownItemBalance onClick={()=>{setShowBalancePopup(false);setWalletPopUpOpen("MLD")}}>
         <TokenContainer>
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={MldTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>$MLD</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {`${truncateNumberBalance(userBalance?.MLDBalanceDec , 2)}`}
              </Tokenprice>
            </Tokenpricewrapper>
         </TokenContainer>
        </DropdownItemBalance>
        <DividerBalance />
        <DropdownItemBalance onClick={()=>{setShowBalancePopup(false);setWalletPopUpOpen("MATIC")}}><TokenContainer>
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={MaticTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>POL</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {`${truncateNumberBalance(userBalance?.MATIC , 4)}`}
              </Tokenprice>
            </Tokenpricewrapper>
         </TokenContainer></DropdownItemBalance>
        <DividerBalance />
        <DropdownItemBalance onClick={()=>{setShowBalancePopup(false);setWalletPopUpOpen("LORD")}}><TokenContainer>
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={LordTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>$LORD</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {`${truncateNumberBalance(userBalance?.LORD , 0)}`}
              </Tokenprice>
            </Tokenpricewrapper>
         </TokenContainer></DropdownItemBalance>
        <DividerBalance />
        <DropdownItemBalance onClick={()=>{setShowBalancePopup(false);setWalletPopUpOpen("USDT")}}><TokenContainer>
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={ustdTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>USDT</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {truncateNumberBalance(userBalance?.USDT,4)}
              </Tokenprice>
            </Tokenpricewrapper>
         </TokenContainer></DropdownItemBalance>
      </DropdownBoxBalance>
    </DropdownContainerBalance>
      </>
    }
    </Root>
  );
};

export default LoginLogoutComponent;
